<template>
  <div class="youtaofang">
    <topTitle title="柏庭荟" :list="list" :newData="newData" :ContentStatus="ContentStatus" :remakTitle="remakTitle"></topTitle>
   
     <p v-html="dataContent" v-if="ContentStatus"></p>
  </div>
</template>
  <script>
import topTitle from "../rightTopTitle";
import axios from "axios";
export default {
  name: "youtaofang",
  data() {
    return {
      list: [
        {
          title: "柏庭荟简介",
          small_title: "BOTING LIVING CLUB INTRODUCTION",
          hasTitle: "柏庭荟简介",
        },
        {
          title: "摄影俱乐部",
          hasTitle: "摄影俱乐部",
          small_title:"PHOTOGRAPHY CLUB"
        },
        {
          title: "旅游俱乐部",
          hasTitle: "旅游俱乐部",
        },
        {
          title: "书画俱乐部",
          hasTitle: "书画俱乐部",
        },
        {
          title: "读书俱乐部",
          hasTitle: "读书俱乐部",
        },
         {
          title: "养生俱乐部",
          hasTitle: "养生俱乐部",
        },
        {
          title: "舞蹈俱乐部",
          hasTitle: "舞蹈俱乐部",
        },
         {
          title: "音乐俱乐部",
          hasTitle: "音乐俱乐部",
        },
         {
          title: "美食俱乐部",
          hasTitle: "美食俱乐部",
        },
         {
          title: "戏曲俱乐部",
          hasTitle: "戏曲俱乐部",
        },
         {
          title: "运动俱乐部",
          hasTitle: "运动俱乐部",
        },
      ],
      newData: 2,
      list2: [
        {
          img: require("../../assets/image/party/lvyou_1.png"),
        },
        {
          img: require("../../assets/image/party/lvyou_2.png"),
        },
        {
          img: require("../../assets/image/party/lvyou_3.png"),
        },
      ],
      dataContent:'',
      ContentStatus:false,
      remakTitle:'',
    };
  },
  methods: {
   
    getHtml(e){
       axios
        .get(
         
            "/api/article?id=" +
            e
        )
        .then((res) => {
    
          if(res.status=='200'){
            this.remakTitle=res.data.article.title;
            // this.list[this.newData].small_title='';

            this.ContentStatus=true;
            this.dataContent=res.data.article.content;
           
          }
         
        });
  
    }
  },
  mounted: function () {
        let number = this.$route.query.majorName;
         let height = this.$store.state.scrollTop;
      document.documentElement.scrollTop = height;
        this.getHtml(number);
    //     this.$router.push({
    //     path: "/details",
    //     query: { majorName: e }
    //   });
  },
  components: {
    topTitle,
  },
  props: {
    
  },
};
</script>
<style scoped="scoped">
p{
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
}
.youtaofang {
  width: 100%;
  height: 100%;
  text-align: left;
}
.top_p {
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
  text-indent: 2em;
}
.item_bd {
  margin-top: 1.1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item_bd img {
  width: 4.0125rem;
  /* height: 3.0125rem; */
  border-radius: 0.125rem;
}
.navGet{
  display: inline-block;
font-size: 32px;
font-family: PingFang SC;
font-weight: 500;
text-decoration: underline;
color: #3F674B;
line-height: 54px;
text-align: left;
margin-top: 0.6rem;
cursor: pointer;
}
</style>